export default {
        "Key": "Wert",
        "startsWith": "Beginnt mit",
        "contains": "Enthält",
        "notContains": "Enthält nicht",
        "endsWith": "Endet mit",
        "equals": "Gleich",
        "notEquals": "Ungleich",
        "noFilter": "Kein Filter",
        "lt": "Kleiner als",
        "lte": "Kleiner oder gleich",
        "gt": "Größer als",
        "gte": "Größer oder gleich",
        "dateIs": "Datum ist",
        "dateIsNot": "Datum ist nicht",
        "dateBefore": "Datum ist vor",
        "dateAfter": "Datum ist nach",
        "clear": "Löschen",
        "apply": "Anwenden",
        "matchAll": "Alle treffen zu",
        "matchAny": "Mindestens eine trifft zu",
        "addRule": "Regel hinzufügen",
        "removeRule": "Regel entfernen",
        "accept": "Ja",
        "reject": "Nein",
        "choose": "Auswählen",
        "upload": "Hochladen",
        "cancel": "Abbrechen",
        "completed": "Abgeschlossen",
        "pending": "Ausstehend",
        "fileSizeTypes": ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        "dayNames": ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
        "dayNamesShort": ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        "dayNamesMin": ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        "monthNames": ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        "monthNamesShort": ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        "chooseYear": "Jahr wählen",
        "chooseMonth": "Monat wählen",
        "chooseDate": "Datum wählen",
        "prevDecade": "Vorheriges Jahrzehnt",
        "nextDecade": "Nächstes Jahrzehnt",
        "prevYear": "Vorheriges Jahr",
        "nextYear": "Nächstes Jahr",
        "prevMonth": "Vorheriger Monat",
        "nextMonth": "Nächster Monat",
        "prevHour": "Vorherige Stunde",
        "nextHour": "Nächste Stunde",
        "prevMinute": "Vorherige Minute",
        "nextMinute": "Nächste Minute",
        "prevSecond": "Vorherige Sekunde",
        "nextSecond": "Nächste Sekunde",
        "am": "vorm.",
        "pm": "nachm.",
        "today": "Heute",
        "weekHeader": "KW",
        "firstDayOfWeek": "1",
        "showMonthAfterYear": "false",
        "dateFormat": "dd.mm.yy",
        "weak": "Schwach",
        "medium": "Mittel",
        "strong": "Stark",
        "passwordPrompt": "Passwort eingeben",
        "searchMessage": "{0} Ergebnisse verfügbar",
        "selectionMessage": "{0} Einträge ausgewählt",
        "emptySelectionMessage": "Kein Eintrag ausgewählt",
        "emptySearchMessage": "Keine Ergebnisse gefunden",
        "fileChosenMessage": "{0} Dateien",
        "noFileChosenMessage": "Keine Datei ausgewählt",
        "emptyMessage": "Keine verfügbaren Optionen",
    }